module.exports = __webpack_public_path__ + "static/img/bottomImg.fa84d12b.png";